import { IntlShape } from 'react-intl';

export function isNumber(value: unknown): boolean {
    const number = Number(value);
    return !Number.isNaN(number) && isFinite(number);
}

export function ensureRange(value: number, min: number, max: number) {
    if (value < min) {
        return min;
    }

    if (value > max) {
        return max;
    }

    return value;
}

export function validateNumber(intl: IntlShape, value: string) {
    if (!isNumber(value)) {
        return intl.formatMessage({
            id: 'validation_invalid_number',
        });
    }
    return null;
}

export function validateInteger(value: string, intl: IntlShape) {
    if (Number.isNaN(Number(value)) || !Number.isInteger(Number(value))) {
        return intl.formatMessage({
            id: 'tsk_invalid_integer',
        });
    }
    return null;
}
